import { Component, input } from "@angular/core";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { TrustedHtmlPipe } from "../../../../common/pipes/trusted-html.pipe";
import { ItemsRitchtextBlock } from "../../../api/packbo/models/items-ritchtext-block";

@Component({
    selector: "packbo-ritchtext-block",
    templateUrl: "./ritchtext-block.template.html",
    imports: [DirectusTranslationPipe, TrustedHtmlPipe]
})
export class RitchtextBlockComponent {
    public readonly ritchtextBlock = input.required<ItemsRitchtextBlock>();
}
